import axios from 'axios';

const FORGOT_PASSWORD_ENDPOINT = '/password/forgot';

export const sendPasswordResetRequest = email => {
  return axios.post(FORGOT_PASSWORD_ENDPOINT, { email });
};
